import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { getCardHistory, getUserData } from '../../../../util/API/cardservices';
import CustomAlert from '../../../UI/CustomAlert/CustomAlert';
import { Visibility } from '@mui/icons-material';
import ReveCardHistoryDetails from './ReveCardHistoryDetails';

const ReveCardHistory = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [cardHistory, setCardHistory] = useState(null);
  const [dates, setDates] = useState({
    assignedDate: '',
    damagedDate: '',
    lostDate: ''
  })
  const [actionUserID, setActionUserId] = useState({
    assignedUserID: '',
    damagedUserID: '',
    lostUserID: ''
  })
  const [alert, setAlert] = useState({
    showAlert: false,
    severity: "error",
    header: "",
    message: ""
  })
  const [lastVisitedRow, setLastVisitedRow] = useState(null); 
  const [open, setOpen] = useState(false);
  const [cardDetails, setCardDetails] = useState()

  const handleRowClick = (rowId) => {
    setLastVisitedRow(rowId); // Update the last visited row ID
  };

  const handleSearch = async () => {
    // if (!searchQuery.trim()) {
    //   return; // Do nothing if the input is empty
    // }

    setIsLoading(true);
    try {
      const response = await getCardHistory(searchQuery);
      console.log(response);
      if (response?.Status === "1") {
        setCardHistory(response?.payload?.body);
        setDates({
          ...dates,
          assignedDate: response?.payload?.body?.PhysicalCard?.assignmentdate,
          damagedDate: response?.payload?.body?.PhysicalCard?.damagedatetime,
          lostDate: response?.payload?.body?.PhysicalCard?.lostdatetime
        })
        setActionUserId({
          ...actionUserID,
          assignedUserID: response?.payload?.body?.PhysicalCard?.assignedby,
          damagedUserID: response?.payload?.body?.PhysicalCard?.damageby,
          lostUserID: response?.payload?.body?.PhysicalCard?.lostby
        })
      }

      else {
        setAlert({
          ...alert,
          showAlert: true,
          severity: "error",
          header: "Error",
          message: `${response?.payload?.msg}`,
        })

        setCardHistory(null)
      }
    } catch (error) {
      console.error('Error fetching card history:', error);
      setCardHistory([]);
    } finally {
      setIsLoading(false);
    }
  };

  console.log(actionUserID)

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  useEffect(() => {
    setCardHistory(null);
  }, []);

  const handleClick = async(row, index) => {

    console.log(row, index)

    // const changeType =
    //   dates?.damagedDate === row.PhysicalCardHistory.change_time
    //     ? "Damaged"
    //     : dates?.lostDate === row.PhysicalCardHistory.change_time
    //     ? "Lost"
    //     : dates?.assignedDate === row.PhysicalCardHistory.change_time
    //     ? "Assigned"
    //     : "N/A";

    const changeType = 
    index === 0 ? (
      cardHistory?.PhysicalCard?.status === "4" ? "Damaged"
      :
      cardHistory?.PhysicalCard?.status === "3" ? "Lost"
      :
      "Assigned"
    ) : 
    index === cardHistory.length - 1 ?
    (
      cardHistory?.PhysicalCard?.status === "2" ? "Activated" : "N/A"
    )
    :
    (
      row.PhysicalCardHistory.change_time === dates?.damagedDate
        ? "Damaged"
        : row.PhysicalCardHistory.change_time === dates?.lostDate
        ? "Lost"
        : "Assigned"
    )
  
    const changedBy =
      dates?.damagedDate === row.PhysicalCardHistory.change_time
        ? actionUserID?.damagedUserID
        : dates?.lostDate === row.PhysicalCardHistory.change_time
        ? actionUserID?.lostUserID
        // : dates?.assignedDate === row.PhysicalCardHistory.change_time
        :actionUserID?.assignedUserID
        // : "N/A";
  
        const response = await getUserData(changedBy, cardHistory.PhysicalCard.assigneduserid)

        console.log(response)

        if (response.Status === "1") {
          let agentInfo = response?.agentInfo
          let customerInfo = response?.customerInfo

          setCardDetails({
            changeType: changeType,
            changeDate: row.PhysicalCardHistory.change_time,
            agentName: agentInfo?.User?.firstName + " " + agentInfo?.User?.lastName,
            agentUsername: agentInfo?.Useremailaccount?.emailAccount,
            agentId: agentInfo?.User?.id,
            customerName: customerInfo?.User?.firstName + " " + customerInfo?.User?.lastName,
            customerId: customerInfo?.User?.id,
            cardNumber: searchQuery,
            customerUsername: customerInfo?.Useremailaccount?.emailAccount
          });

          setOpen(true); // Open the modal
        }

  
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <ReveCardHistoryDetails open={open} handleCloseModal={() => setOpen(false)} cardDetails={cardDetails} />
      <Box
        sx={{
          marginTop: 4,
          padding: 4,
          borderRadius: 4,
          backgroundColor: '#fff',
          width: '80%',
          marginLeft: 'auto',
          marginRight: 'auto',
          textAlign: 'center',
        }}
      >
        <Typography variant="h5" sx={{ marginBottom: 4, fontFamily: 'Nunito', color: '#333' }}>
          Search Cards and Card History
        </Typography>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            fontFamily: 'Nunito',
          }}
        >
          <TextField
            placeholder="Enter a card number and press enter..."
            fullWidth
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={handleKeyDown}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '30px',
                paddingLeft: 2,
              },
              maxWidth: 600,
            }}
          />
        </Box>

        {isLoading ? (
          <CircularProgress sx={{ marginTop: 4 }} />
        ) : (
           cardHistory && (
            <TableContainer sx={{ marginTop: 4 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell><strong>Assigned User (ID)</strong></TableCell>
                    <TableCell><strong>Changed By (ID)</strong></TableCell>
                    <TableCell><strong>Change Type</strong></TableCell>
                    <TableCell><strong>Change Date</strong></TableCell>
                    <TableCell><strong>Action</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(() => {
                    const cardHistoryArray = Array.isArray(cardHistory?.CardHistory)
                      ? cardHistory?.CardHistory
                      : cardHistory?.CardHistory
                      ? [cardHistory?.CardHistory] 
                      : [];

                    return cardHistoryArray.map((item, index) => (
                      <TableRow
                        key={item.PhysicalCardHistory.cardid}
                        onClick={() => handleRowClick(item.PhysicalCardHistory.change_time)}
                        sx={{
                          backgroundColor:
                            lastVisitedRow === item.PhysicalCardHistory.change_time
                              ? "#dbefff"
                              : "inherit",
                        }}
                      >
                        <TableCell>{cardHistory.PhysicalCard.assigneduserid}</TableCell>
                        <TableCell>
                          {dates?.damagedDate === item.PhysicalCardHistory.change_time
                            ? actionUserID?.damagedUserID
                            : dates?.lostDate === item.PhysicalCardHistory.change_time
                            ? actionUserID?.lostUserID
                            : actionUserID?.assignedUserID
                          }
                        </TableCell>
                        <TableCell>
                        {index === 0 ? (
                          cardHistory?.PhysicalCard?.status === "4" ? "Damaged"
                          :
                          cardHistory?.PhysicalCard?.status === "3" ? "Lost"
                          :
                          "Assigned"
                        ) : 
                        index === cardHistory.length - 1 ?
                        (
                          cardHistory?.PhysicalCard?.status === "2" ? "Activated" : "N/A"
                        )
                        :
                        (
                          item.PhysicalCardHistory.change_time === dates?.damagedDate
                            ? "Damaged"
                            : item.PhysicalCardHistory.change_time === dates?.lostDate
                            ? "Lost"
                            : "Assigned"
                        )}
                        </TableCell>
                        <TableCell>{item.PhysicalCardHistory.change_time || "N/A"}</TableCell>
                        <TableCell>
                          <IconButton onClick={() => handleClick(item, index)}>
                            <Visibility />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ));
                  })()}

                  {cardHistory?.PhysicalCard?.creationdate && 
                  <TableRow 
                  key={cardHistory?.PhysicalCard?.cardid}
                  onClick={() => handleRowClick(cardHistory?.PhysicalCard?.creationdate)}
                  sx={{
                    backgroundColor: lastVisitedRow === cardHistory?.PhysicalCard?.creationdate ? '#dbefff' : 'inherit',
                  }}
                  >
                    <TableCell>{cardHistory?.PhysicalCard?.assigneduserid}</TableCell>
                    <TableCell>{cardHistory?.PhysicalCard?.assignedby}</TableCell>
                    <TableCell>{"Assigned"}</TableCell>
                    <TableCell>{cardHistory?.PhysicalCard?.assignmentdate}</TableCell>
                    <TableCell/>
                  </TableRow>}
                </TableBody>
              </Table>
            </TableContainer>
          )
        )}
      </Box>
      <CustomAlert 
        severity={alert.severity} 
        show={alert.showAlert} 
        header={alert.header} 
        message={alert.message} 
        onClick={(prev) => setAlert({...prev, showAlert: false})} 
        autoclose={alert.severity === "error" ? false : true} 
      />
    </Box>
  );
};

export default ReveCardHistory;
